import { WrapPage, Loading, Toast, Icon } from 'common/ui'
import CreateTokenBtn from '@/component/CreatTokenBtn'
import styled from 'styled-components'
import { appConfig } from '@/constants'
import { useCallback, useEffect, useState } from 'react'
import { address as getAddressService } from 'common/api'
import { useThrottle, useDioxAddressContext, Address } from 'common/hooks'
import { useMemo } from 'react'
import TokenCard from '@/component/TokenCard'
import { DIOX } from 'common/api'
import { NextPageContext } from 'next'

const addressService = getAddressService()
const HomeStyled = styled.div`
  .empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    transform: translateY(-50%);
    img {
      width: 389px;
      height: 183px;
      margin-bottom: 24px;
    }
    p {
      font-weight: 400;
      font-size: 16px;
      line-height: normal;
      color: #a3a3a3;
      margin-bottom: 58px;
      text-align: center;
    }
    button {
      font-weight: 600;
      width: 164px;
    }
    .refresh {
      font-size: 50px;
      margin-bottom: 12px;
      cursor: pointer;
      :hover {
        transform: rotate(360deg);
        transition: transform 0.6s ease-in;
      }
    }
  }
  .tokens-box {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .header {
    margin-bottom: 20px;
    padding-top: 34px;
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    position: relative;
    z-index: 2;
    .title {
      font-weight: 700;
      font-size: 24px;
      line-height: 30px;
      color: #ffffff;
    }
    button {
      width: 141px;
      height: 40px;
      padding: 0;
    }
  }
`

const Home = ({
  pageProps = {},
}: {
  pageProps: { tokens?: DIOX.MyTokenBase[] }
}) => {
  const { address } = useDioxAddressContext()
  const [tokens, setTokens] = useState<Array<DIOX.MyTokenBase>>(
    pageProps.tokens || []
  )
  const [loading, setLoading] = useState(true)
  const [cacheAddr, setCacheAddr] = useState<string | null>(null)

  useEffect(() => {
    // 地址会刷新两次，第一次是基本信息，第二次是balance和metadata
    if (cacheAddr !== address) {
      setCacheAddr(address?.address || null)
    }
  }, [address, cacheAddr])

  useEffect(() => {
    getAddressTokenList()
  }, [cacheAddr])

  const getAddressTokenList = useThrottle(async () => {
    const addr = address?.address
    if (!addr) return
    setLoading(true)
    try {
      const res = await addressService.getMyTokenList(addr)
      const txns = res?.Result || []
      if (txns.length) {
        const tokens: Array<DIOX.MyTokenBase> = []
        txns.forEach((txn) => {
          tokens.push({
            IconUrl: txn.IconUrl || '',
            Decimals: txn.Decimals,
            ID: txn.CVID,
            Symbol: txn.Symbol,
            Address: txn.Address,
            TotalSupply: txn.TotalSupply,
            Status: txn.TxnStatus,
            Time: txn.BlockTime,
          })
        })
        setTokens(tokens)
      } else {
        setTokens([])
      }
    } catch (e: any) {
      Toast({ text: e?.message })
    }
    setLoading(false)
  }, 500)

  const isEmpty = useMemo(() => {
    return !tokens.length
  }, [tokens])

  return (
    <HomeStyled>
      {loading ? (
        <div className="empty">
          <Loading />
        </div>
      ) : (
        <>
          <div className="header">
            <h3 className="title">My Token</h3>
            <CreateTokenBtn icon="create-token">Create Token</CreateTokenBtn>
          </div>
          {isEmpty ? (
            <div className="empty">
              <img src="/img/empty.png" alt="empty" />
              <p>
                No Token yet.
                <br />
                <br />
                If you have Created a Token , please reload the page
              </p>
              <Icon
                className="refresh"
                type="refresh"
                onClick={getAddressTokenList}
              />
              <p>Reload</p>
            </div>
          ) : (
            <div className="tokens-box">
              {tokens.map((token) => (
                <TokenCard data={token} key={token.Symbol} />
              ))}
            </div>
          )}
        </>
      )}
    </HomeStyled>
  )
}

// Home.getInitialProps = async (ctx: NextPageContext) => {
//   const pageProps: { [key: string]: any } = {}
//   const cacheAddress = (ctx.req as any)?.cookies?.cacheAddress

//   try {
//     if (cacheAddress) {
//       const addr = JSON.parse(cacheAddress).address
//       const res = await addressService.getMyTokenList(addr)
//       const txns = res?.Result || []
//       if (txns.length) {
//         const tokens: Array<DIOX.MyTokenBase> = []
//         txns.forEach(txn => {
//           tokens.push({
//             IconUrl: txn.IconUrl || '',
//             Decimals: txn.Decimals,
//             ID: txn.CVID,
//             Symbol: txn.Symbol,
//             Address: txn.Address,
//             TotalSupply: txn.TotalSupply,
//             Status: txn.TxnStatus,
//             Time: txn.BlockTime,
//           })
//         })
//         pageProps.tokens = tokens
//       }
//     }
//     return { pageProps }
//   } catch (err) {
//     return { ...pageProps }
//   }
// }

export default WrapPage(Home, appConfig)
